module.exports = __webpack_public_path__ + "img/head2.13c532fe.jpg";